import { db } from './api';
import { collection, doc, getDocs, query, where, setDoc, Timestamp, runTransaction, getDoc } from "firebase/firestore";

export const getForums = async () => {
    try {
        const foros = collection(db, "forum");
        const querySnapshot = await getDocs(foros);
        let forosArray = [];
        querySnapshot.forEach((doc) => {
            let foro = doc.data();
            foro.id = doc.id;
            forosArray.push(foro);
        });
        return forosArray;
    } catch (error) {
        console.error(error);
        return null;
    }
}

/**
 * 
 * @param {string} title titulo del foro
 * @param {string} description contenido del foro
 * @param {string} autor nombre del autor
 * @param {string} autorId id del autor
 * @returns 
 */
export const createForum = async (title, description, autor, autorId) => {
    try {
        const foros = collection(db, "forum");
        const newForo = await setDoc(doc(foros), {
            title: title,
            description: description,
            autor: autor,
            created: Timestamp.fromDate(new Date()),
            autorId: autorId,
            likes: 0,
            comments: 0
        });
        return true;
    }   catch (error) {
        console.error(error);
        return false;
    }
}


export const getComments = async (foroId) => {
    try {
        const comentarios = collection(db, "comments");
        const q = query(comentarios, where("foroId", "==", foroId));
        const querySnapshot = await getDocs(q);
        let comentariosArray = [];
        querySnapshot.forEach((doc) => {
            let comentario = doc.data();
            comentario.id = doc.id;
            comentariosArray.push(comentario);
        });
        return comentariosArray;
    } catch (error) {
        console.error(error);
        return null;
    }
}

/**
 * función para crear un comentario
 * @param {string} foroId id del foro
 * @param {string} comentario comentario
 * @param {string} autor nombre del autor
 * @param {string} autorId id del autor
 * @returns 
 */
export const createComments = async (foroId, comentario, autor, autorId) => {
    try {
      await runTransaction(db, async (transaction) => {
        // Referencia al nuevo documento de comentario
        const newCommentRef = doc(collection(db, "comments"));
        // Referencia al documento del foro para actualizar el contador de comentarios
        const forumRef = doc(db, "forum", foroId);

        // Obtener el documento del foro dentro de la transacción para asegurarse de que es la versión más reciente
        const forumDoc = await transaction.get(forumRef);
        if (!forumDoc.exists()) {
          throw new Error("Document does not exist!");
        }


        // Crear el nuevo comentario
        transaction.set(newCommentRef, {
          foroId: foroId,
          comentario: comentario,
          autor: autor,
          date: Timestamp.fromDate(new Date()),
          autorId: autorId
        });
  
        
  
        // Incrementar el contador de comentarios en el documento del foro
        const currentComments = forumDoc.data().comments || 0;
        transaction.update(forumRef, { comments: currentComments + 1 });
      });
  
      return true;
    } catch (error) {
      console.error("Error creating comment: ", error);
      return false;
    }
};


/**
 * función para dar like a un foro
 * @param {string} userId id del usuario
 * @param {string} forumId id del foro
 * @returns 
 */
export const giveLikeToForum = async (userId, forumId) => {
    try {
        const likesCollectionRef = collection(db, "likes");
        const forumRef = doc(db, "forum", forumId);

        const likeResult = await runTransaction(db, async (transaction) => {
        // Verificar si el usuario ya ha dado like a este foro
        const likesQuery = query(likesCollectionRef, where("userId", "==", userId), where("forumId", "==", forumId));
        const likesQuerySnapshot = await getDocs(likesQuery);
        if (!likesQuerySnapshot.empty) {
            return false; // Ya ha dado like
        }

        

        // Actualizar el contador de likes del foro
        const forumDoc = await transaction.get(forumRef);
        if (!forumDoc.exists()) {
            throw new Error("Forum document does not exist!");
        }
        const currentLikes = forumDoc.data().likes || 0;
        transaction.update(forumRef, { likes: currentLikes + 1 });
        const newLikeRef = doc(likesCollectionRef);
        transaction.set(newLikeRef, {
            userId: userId,
            forumId: forumId
        });
        return true; // Like dado con éxito
        });
        

        return likeResult;
    } catch (error) {
        console.error("Error giving like to forum: ", error);
        return false;
    }
};


/**
 * función para obtener los foros de un usuario
 * @param {string} userId id del usuario
 * @returns 
 */
export const getForumsByUser = async (userId) => {
    try {
        const foros = collection(db, "forum");
        const q = query(foros, where("autorId", "==", userId));
        const querySnapshot = await getDocs(q);
        let forosArray = [];
        querySnapshot.forEach((doc) => {
            let foro = doc.data();
            foro.id = doc.id;
            forosArray.push(foro);
        });
        return forosArray;
    } catch (error) {
        console.error(error);
        return [];
    }
}

/**
 * Función para agregar una foto a un foro
 * @param {string} foroId id del foro
 * @param {string} photo url de la foto
 * @returns 
 */
export const updateForoPhoto = async (foroId, photo) => {
    try {
        const petRef = doc(db, "forum", foroId);
        await setDoc(petRef, {photo: photo}, {merge: true});
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
}